import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { MerchantAccountService, MerchantAccount } from '../../shared';

@Injectable({
    providedIn: 'root'
})
export class MerchantAccountByIdResolver implements Resolve<MerchantAccount> {
    constructor(private readonly merchantAccountService: MerchantAccountService) { }

    resolve(route: ActivatedRouteSnapshot) {
        const id = route.params.id;
        return this.merchantAccountService.getMerchantAccount(id);
    }
}